export default function isLicenceValidity(licenceStartDate, licenceEndDate) {
    const startDate = new Date(licenceStartDate)
    const endDate = new Date(licenceEndDate)
    const currentDate = new Date()
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        return false
    }
    startDate.setUTCHours(0, 0, 0, 0)
    endDate.setUTCHours(0, 0, 0, 0)
    currentDate.setUTCHours(0, 0, 0, 0)
    return currentDate >= startDate && currentDate <= endDate
}